import React from "react";
import moment from "moment";

import WComponent from "../common/WComponent";
import ToolsClientSearch from "../clients/Tools/kit/ToolsClientSearch";
import ToolsSelect from "../clients/Tools/kit/ToolsSelect";
import PlaybookScriptService from "../../services/PlaybookScriptService";

const TEST_BUSY_KEY = "testScript";
const MONTH_ENDS_OFFERED = 24;
const MONTH_END_VALUE_FORMAT = "YYYY-MM-DD";
const MONTH_END_LABEL_FORMAT = "MMM D, YYYY";

class PlaybookScriptTestForm extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			chosenClient: null,
			periodEnd: null,
			refusal: null,
		};
	}

	onRun = async () => {
		const { script, sessionId, runScriptAction, onTested } = this.props;
		const { chosenClient, periodEnd } = this.state;
		const clientId = chosenClient.id;
		const periodEndSent = script.readsAPeriod ? periodEnd : null;
		await this.update({ refusal: null });
		const { answer, refusal } = await runScriptAction({
			busyKey: TEST_BUSY_KEY,
			action: () => PlaybookScriptService.testBuildScript({ sessionId, pinId: script.pinId, clientId, periodEnd: periodEndSent }),
			pinId: script.pinId,
		});
		if (refusal) {
			await this.update({ refusal });
			return;
		}
		if (answer) onTested({ answer });
	};

	render() {
		const { script, busyKey } = this.props;
		const { chosenClient, periodEnd, refusal } = this.state;
		const isBusy = busyKey !== null && busyKey !== undefined;
		const isTesting = busyKey === TEST_BUSY_KEY;
		const isMonthNeeded = Boolean(script.readsAPeriod);
		const isMonthChosen = !isMonthNeeded || Boolean(periodEnd);
		const canRun = Boolean(chosenClient) && isMonthChosen && !isBusy;
		const monthEndOptions = Array.from({ length: MONTH_ENDS_OFFERED }, (unused, index) => {
			const monthEnd = moment().subtract(index + 1, "months").endOf("month");
			const option = { value: monthEnd.format(MONTH_END_VALUE_FORMAT), label: monthEnd.format(MONTH_END_LABEL_FORMAT) };
			return option;
		});

		return (
			<div className="playbook-script-test">
				<div className="playbook-script-test__fields">
					<div className="tk-form-field playbook-script-test__field">
						<div className="tk-form-label">Client</div>
						<ToolsClientSearch
							chosen={chosenClient}
							onChoose={({ client }) => this.update({ chosenClient: client, refusal: null })}
							onClear={() => this.update({ chosenClient: null, refusal: null })}
							placeholder="Find the client to test on…"
							disabled={isBusy}
						/>
					</div>
					{isMonthNeeded && (
						<div className="tk-form-field playbook-script-test__field">
							<div className="tk-form-label">Month ending</div>
							<ToolsSelect
								value={periodEnd}
								options={monthEndOptions}
								onChange={value => this.update({ periodEnd: value, refusal: null })}
								placeholder="Choose the month…"
								disabled={isBusy}
							/>
						</div>
					)}
					<button type="button" className="tk-button tk-button--secondary playbook-script-test__run" onClick={this.onRun} disabled={!canRun}>
						{isTesting ? "Testing…" : "Test on this client"}
					</button>
				</div>
				{refusal && <div className="tk-notice tk-notice--danger playbook-script-test__refusal">{refusal}</div>}
			</div>
		);
	}
}

export default PlaybookScriptTestForm;
